import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({ selector: "[CharactersAndNumbers]" })
export class CharactersAndNumbersDirective {
  constructor(private hostElement: ElementRef) {}

  @HostListener("input") onInput() {
    const value = this.hostElement.nativeElement.value;
    const charNumValue = value.replace(/[^a-zA-Z0-9\s]/g, "");

    if (value !== charNumValue) {
      this.hostElement.nativeElement.value = charNumValue;
    }
  }
}
